import { applyMiddleware, createStore, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import reducer from './reducer';

const cart = window.CART_STATE;

function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    reducer,
    { cart },
    composeEnhancers(
      applyMiddleware(thunk, logger)
    ),
  );
}

export default configureStore();


// WEBPACK FOOTER //
// ./assets/scripts/redux/configureStore.js